import { defineMessages } from 'react-intl';

export default defineMessages({
    youEntered: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.propertyColomn.You Provided',
        defaultMessage: 'You Provided'
    },
    consumerReportsShow: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.propertyColomn.Reports Show',
        defaultMessage: 'Reports Show'
    },
    consumerReportHelpText:{
        id: 'ml.quoteandbind.pa.hvq.discrepancies.propertyColomn.consumerReportHelpText',
        defaultMessage: 'What are consumer reports? They are information provided by consumer reporting agencies that include your driving record, auto and home claim history and credit report.'
    }
});
